// --- LENIS & SETUP ---
const lenis = new Lenis({ duration: 1.2, easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)), direction: 'vertical', smooth: true });
function raf(time) { lenis.raf(time); requestAnimationFrame(raf); }
requestAnimationFrame(raf);
gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

// --- MOBILE MENU LOGIC ---
const hamburgerBtn = document.getElementById('hamburgerBtn');
const closeMenuBtn = document.getElementById('closeMenuBtn');
const mobileMenu = document.getElementById('mobileMenu');
const mobileLinks = document.querySelectorAll('.mobile-link');

function toggleMenu(show) {
    if(show) {
        mobileMenu.classList.add('active');
        // Prevent scrolling when menu is open
        document.body.style.overflow = 'hidden';
        // Animate links
        gsap.fromTo(mobileLinks, 
            {y: 20, opacity: 0},
            {y: 0, opacity: 1, stagger: 0.1, duration: 0.4, delay: 0.1}
        );
    } else {
        mobileMenu.classList.remove('active');
        document.body.style.overflow = '';
    }
}

hamburgerBtn.addEventListener('click', () => toggleMenu(true));
closeMenuBtn.addEventListener('click', () => toggleMenu(false));

// Close menu when a link is clicked
mobileLinks.forEach(link => {
    link.addEventListener('click', () => {
        toggleMenu(false);
        // Scroll to section
        const targetId = link.getAttribute('href');
        setTimeout(() => lenis.scrollTo(targetId), 300);
    });
});

// --- PRODUCT VARIATION LOGIC ---
const products = {
    lavender: {
        title: "Lavendel",
        desc: "Inspiriert von der Natur. Ein beruhigender Duft von frischen Lavendelfeldern für entspanntes Saugen. Perfekt nach einem stressigen Tag.",
        img: "https://images.unsplash.com/photo-1595981267035-7b04ca84a82d?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
        bgClass: "bg-[#F3E8FF]",
        btnColor: "#A855F7"
    },
    citrus: {
        title: "Zitrus",
        desc: "Belebende Zitrusnoten für den ultimativen Frischekick. Bringt den Sommer und gute Laune direkt in dein Wohnzimmer.",
        img: "https://images.unsplash.com/photo-1626808642875-0aa545482dfb?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
        bgClass: "bg-[#FEF9C3]",
        btnColor: "#EAB308"
    },
    ocean: {
        title: "Ozean",
        desc: "Eine kühle Meeresbrise. Erfrischend, klar und reinigend wie ein Spaziergang am Strand nach einem Sommerregen.",
        img: "https://images.unsplash.com/photo-1441974231531-c6227db76b6e?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
        bgClass: "bg-[#CFFAFE]",
        btnColor: "#06B6D4"
    }
};

function changeProduct(variant) {
    const data = products[variant];
    const img = document.getElementById('product-image');
    const bg = document.getElementById('product-bg');
    const title = document.getElementById('product-title');
    const desc = document.getElementById('product-desc');
    const btn = document.getElementById('add-to-cart-btn');

    gsap.to([img, title, desc], { opacity: 0, y: 10, duration: 0.3, onComplete: () => {
        img.src = data.img;
        title.textContent = data.title;
        desc.textContent = data.desc;
        bg.className = `relative h-80 md:h-[500px] lg:h-auto flex items-center justify-center transition-colors duration-700 ${data.bgClass}`;
        gsap.to(btn, { backgroundColor: data.btnColor, duration: 0.3 });
        gsap.to([img, title, desc], { opacity: 1, y: 0, duration: 0.5 });
    }});

    document.querySelectorAll('.color-btn').forEach(b => b.classList.remove('active'));
    event.currentTarget.classList.add('active');
}


// --- PAGE ANIMATIONS ---
const tlHero = gsap.timeline();
tlHero.to(".hero-badge-container", { opacity: 1, y: 0, duration: 0.8, ease: "power3.out" })
      .to(".hero-title", { opacity: 1, y: 0, duration: 0.8, ease: "power3.out" }, "-=0.6")
      .to(".hero-text", { opacity: 1, y: 0, duration: 0.8, ease: "power3.out" }, "-=0.6")
      .to(".hero-btns", { opacity: 1, y: 0, duration: 0.8, ease: "power3.out" }, "-=0.6")
      .to(".hero-image-container", { opacity: 1, duration: 1.5, ease: "power4.out" }, "-=0.4");

gsap.to(".marquee-content", { xPercent: -50, repeat: -1, duration: 25, ease: "linear" });

gsap.utils.toArray(".step-card, .faq-item, .hoverable").forEach((el) => {
    if(el.classList.contains('nav-link') || el.classList.contains('color-btn') || el.classList.contains('mobile-link')) return;
    gsap.from(el, {
        scrollTrigger: { trigger: el, start: "top 90%" },
        y: 40, opacity: 0, duration: 0.8, delay: 0.1, ease: "power3.out"
    });
});

gsap.from(".image-reveal img", {
    scrollTrigger: { trigger: ".image-reveal", start: "top bottom", end: "bottom top", scrub: true },
    scale: 1.2
});

// --- FIXED FAQ ACCORDION LOGIC ---
document.querySelectorAll('.faq-item').forEach(item => {
    item.addEventListener('click', () => {
        const answer = item.querySelector('.faq-answer');
        const icon = item.querySelector('.icon-rotate');
        
        // Determine if currently open by checking inline style or computed height
        const isOpen = answer.style.height && answer.style.height !== '0px';

        // Close all others
        document.querySelectorAll('.faq-answer').forEach(otherAnswer => {
            if (otherAnswer !== answer) {
                gsap.to(otherAnswer, { height: 0, duration: 0.3, ease: "power2.out" });
            }
        });
        document.querySelectorAll('.icon-rotate').forEach(otherIcon => {
            if (otherIcon !== icon) {
                gsap.to(otherIcon, { rotation: 0, duration: 0.3 });
            }
        });

        // Toggle current
        if (isOpen) {
            gsap.to(answer, { height: 0, duration: 0.3, ease: "power2.out" });
            gsap.to(icon, { rotation: 0, duration: 0.3 });
            answer.style.height = '0px'; // Force manual set for state check
        } else {
            gsap.to(answer, { height: "auto", duration: 0.3, ease: "power2.out" });
            gsap.to(icon, { rotation: 45, duration: 0.3 });
        }
    });
});

document.querySelectorAll('.nav-link').forEach(anchor => {
    anchor.addEventListener('click', function(e) { 
        const href = this.getAttribute('href');
        // Only prevent default and smooth scroll for hash links
        if (href && href.startsWith('#')) {
            e.preventDefault(); 
            const target = document.querySelector(href);
            if (target) {
                lenis.scrollTo(href);
            }
        }
        // Regular URLs will work normally
    });
});